<template>
    <v-list
      class="draggable-item"
    >
      <v-list-tile>
        <v-list-tile-action>
          <v-icon large>place</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            <strong>{{ item.name }}</strong>
          </v-list-tile-title>
          <v-list-tile-sub-title>
            <v-icon>label</v-icon>
            <span class="caption">{{ item.type }}</span>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
</template>

<script>

export default {
  props: ["item"],
};
</script>

<style>
</style>